import { SettingsStorageMixin } from "@/services/storage/storage-mixins/settings-storage-mixin";
import { TextToSpeechSettingsField } from "@/services/storage/text-to-speech-session-storage";

export class TextToSpeechSettingsStorageMixin extends SettingsStorageMixin<TextToSpeechSettingsField> {
  protected setSettingsInternal(
    settings: any,
    value: any,
    field: TextToSpeechSettingsField,
  ): void {
    settings[field] = value;
  }
}
